<template>
  <div id="about" class="container-fluid">
    <div class="row p-3">
      <div class="col-md-2 d-none d-sm-block"></div>
      <div class="col-md-8 container-fluid">
        <div class="row">
          <div class="col-md-6">
            <h2>About</h2>
            <p>Fidelior is a platform that provides tools to flag questionable citations.</p>
            <p>Our platform currently searches across 145,000+ records drawing on 16 journal lists available in the public domain.</p>
            <p>We envisage that the fidelior platform will become a global best practice facilitating publishing with integrity, benefitting all stakeholders in the scholarly eco-system.</p>
          </div>
          <div class="col-md-6">
            <iframe
              class="iframe-fill"
              src="https://www.youtube.com/embed/H_V7OFUj6CA"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
      <div class="col-md-2 d-none d-sm-block"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>